export default __webpack_public_path__ + "static/media/budget.117862bb.svg";